module.exports = __webpack_public_path__ + "img/lazer2.b81a2b9a.svg";